<script lang="ts" setup>
import type { FavoriteList } from '~/models/Favorites'
import { useI18n } from 'vue-i18n'
import { PendoFeature } from '~/models/Pendo'
import Button from '~/components/ui/Button.vue'

const props = defineProps<{
  item: FavoriteList
  isLoading: boolean
}>()

const emit = defineEmits<{
  close: []
  duplicate: [item: FavoriteList]
}>()

const { t } = useI18n()
</script>

<template>
  <div class="space-y-6">
    <p
      class="col-span-2"
      v-text="t('favorite.duplicateConfirmationText', { name: props.item.name })"
    />
    <div class="flex justify-end gap-2">
      <Button
        variant="ghost"
        size="lg"
        :disabled="isLoading"
        @click="emit('close')"
      >
        {{ t('cancel') }}
      </Button>
      <Button
        v-focus
        :data-pendo="PendoFeature.Favorites.DuplicateList"
        :disabled="isLoading"
        size="lg"
        variant="solid"
        @click="emit('duplicate', props.item)"
      >
        {{ t('favorite.duplicateList') }}
      </Button>
    </div>
  </div>
</template>
